module.exports = __webpack_public_path__ + "static/img/sbvt.fe84702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/sbvt.png
// module id = ObGl
// module chunks = 0